type IconProps = {
  style?: React.CSSProperties;
};

export const CircleCheckIcon = ({ style = {} }: IconProps) => {
  return (
    <img
      src="/assets/icons/circle-check-icon.svg"
      alt="Checked"
      style={{ height: '1.4rem', ...style }}
    />
  );
};
